import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import { WeatherLocation } from '../types/WeatherLocation';

export const useWeatherLocationMutators = () => {
  const { isGod } = useAuth();

  // Creates a stub WeatherLocation with no lat/lng — the Functions trigger geocodes it
  const createWeatherLocation = async (name: string, firstCourseId: string): Promise<string | null> => {
    if (!isGod) {
      console.error('Permission denied: only god admins can create weather locations');
      return null;
    }
    try {
      const locRef = doc(collection(firestore, 'weatherLocation'));
      const stub: WeatherLocation = {
        itemId: locRef.id,
        name,
        lat: 0,
        lng: 0,
        courseIds: [firstCourseId],
        createdFromCourseId: firstCourseId,
        updatedAt: serverTimestamp(),
      };
      await setDoc(locRef, stub);
      return locRef.id;
    } catch (error) {
      console.error('Error creating weather location:', error);
      return null;
    }
  };

  return { createWeatherLocation };
};
